import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { useBulkActions } from "@components/transactions/TransactionsBulkActions/useBulkActions";
import { AccrualReviewTab, isAccrualReviewTab } from "./accrualReviewTaskView";

const TAB_ITEMS: Array<PickerItemData<AccrualReviewTab>> = [
    { value: AccrualReviewTab.TO_REVIEW, label: "To review" },
    { value: AccrualReviewTab.REVIEWED, label: "Reviewed" },
];

interface AccrualReviewTabsProps {
    value: AccrualReviewTab;
    onValueChange: (tab: AccrualReviewTab) => void;
}

/**
 * To review / Reviewed picker in the accrual review task toolbar. Clears the
 * row selection on change, since selected rows leave the table.
 */
export const AccrualReviewTabs = ({
    value,
    onValueChange,
}: AccrualReviewTabsProps) => {
    const { clearSelection } = useBulkActions();

    return (
        <Picker.Select
            items={TAB_ITEMS}
            value={value}
            onValueChange={(nextValue) => {
                if (
                    typeof nextValue === "string" &&
                    isAccrualReviewTab(nextValue) &&
                    nextValue !== value
                ) {
                    clearSelection();
                    onValueChange(nextValue);
                }
            }}
        />
    );
};
